import { createOperationSelector, getOperation } from 'relay-runtime';
import { graphql } from 'react-relay';
import createEnvironment from '../relayClientEnvironment';
import { getUserId } from 'dibs-cookie-jar';
import { init } from "./userTracking";
// relay needs this import
import userTracking from "./userTracking"; // eslint-disable-line no-unused-vars

export const trackingQuery = graphql`
    query initializeTrackingQuery (
            $hasUserId: Boolean!
            $userId: String!
            $userIds: [String!]
        ) {
            viewer {
                ...userTracking_viewer @relay(mask: false)
                user(userId: $userId) @include(if: $hasUserId) {
                    ...userTracking_user @relay(mask: false)
                }
            }
        }
`;

export default function (environment) {
    environment = environment || createEnvironment();
    const userId = getUserId(document.cookie) || "";
    const hasUserId = !!userId;
    const operation = createOperationSelector(
        getOperation(trackingQuery),
        {
            userId,
            hasUserId,
            userIds: [userId]
        }
    );

    environment.retain(operation.root);
    return new Promise((resolve, reject) => {
        environment.sendQuery({
            operation,
            onNext: () => {
                const {viewer} = environment.lookup(operation.fragment).data;
                init({viewer, user: viewer.user});
            },
            onError: (error) => {
                reject(error);
            }
        });
    });

}



// WEBPACK FOOTER //
// ./src/utils/initializeTracking.js